<template>
	<div>
		<v-autocomplete
			:class="dense ? 'grv-input-dense' : 'grv-input'"
			class="chiped-input"
			:menu-props="{contentClass: 'grv-menu'}"
			:rules="rules"
			@update:error="errored = $event"
			:value="value"
			clearable
			:items="items"
			:loading="loading"
			:name="param.name"
			item-text="label"
			item-value="id"
			:search-input.sync="search"
			:multiple="multiple"
			:readonly="readonly"
			auto-select-first
			:dense="dense"
			no-filter
			hide-no-data
			chips
			:small-chips="dense"
			:deletable-chips="!readonly"
			append-icon="search"
			@click:append="explorer_show = true"
			placeholder="Rechercher un programme"
			@change="$emit('update:value', $event)">

			<template v-slot:label>
				<Label :param="param"></Label>
			</template>

			<template v-slot:item="{ tile, item }">
				<v-list-tile-avatar>
					<v-icon v-if="tile.props.value" color="primary">check_box</v-icon>
					<v-icon v-else>check_box_outline_blank</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content :title="`${item.id} | ${item.type_text} | ${$maestro.babel_card_label(item)}`">
					<v-list-tile-title>
						{{ $maestro.babel_card_label(item) }}
					</v-list-tile-title>
					<v-list-tile-sub-title class="font-italic caption">
						{{ item.type_text }}
					</v-list-tile-sub-title>
				</v-list-tile-content>
				<v-list-tile-action>
					#{{ item.id }}
				</v-list-tile-action>
			</template>

			<template v-slot:selection="{ item }">
				<span
					class="limited-length"
					:title="`${item.id} | ${item.type_text} | ${$maestro.babel_card_label(item)}`">
					{{ $maestro.babel_card_label(item) }} | {{ item.type_text }}
				</span>
			</template>
		</v-autocomplete>

		<Hint :param="param" :errored="errored"></Hint>

		<Babel
			v-if="explorer_show"
			:multiselect="false"
			:toolbarTitle="'Rechercher un programme'"
			@close="explorer_show = false"
			@selected="onCardsSelected($event)">
			<h3 slot="header">Babel ID(s) Select for Maestro ingester</h3>
		</Babel>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
import Babel from '@/components/modal_babel.vue'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Babel,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			items: [],
			ids: [],
			search: null,
			loading: false,
			explorer_show: false
		}
	},
	computed: {
		multiple () {
			return this.param.type.indexOf('multi-babelid') === 0
		}
	},
	watch: {
		search (val) {
			if (val && this.ids.indexOf(val) === -1) {
				this.onSearch(val)
			}
		},
		value (val) {
			if (Array.isArray(val)) {
				let needGetBabels = false
				val.map(id => {
					if (this.ids.indexOf(id) === -1) needGetBabels = true
				})
				if (needGetBabels) this.searchBabels(val)
			} else {
				if (val && this.ids.indexOf(val) === -1) this.searchBabels(val)
			}
		}
	},
	methods: {
		onCardsSelected (evt) {
			let card = {
				id: evt[0].id,
				label: evt[0].label,
				type_text: evt[0].type_text
			}
			this.items = [card]
			this.ids = [card.id]
			this.$emit('update:value', card.id)
		},
		onSearch: debounce(function (search) {
			if (!search) return
			if (this.loading) return
			this.searchBabels(search)
		}, 100),
		searchBabels (search) {
			this.loading = true
			this.$EsMaestro.card_search_or_read(search)
				.then(results => {
					if (Array.isArray(this.value)) {
						this.items = this.items.filter(item => {
							return this.value.indexOf(item.id) > -1
						})
						this.ids = this.ids.filter(id => {
							return this.value.indexOf(id) > -1
						})
					} else {
						this.items = this.items.filter(item => {
							return this.value === item.id
						})
						this.ids = this.ids.filter(id => {
							return this.value === id
						})
					}
					results.map(item => {
						this.items.push(item)
						this.ids.push(item.id)
					})
				})
				.catch(err => {
					console.log(err)
				})
				.finally(() => (this.loading = false))
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			if (Array.isArray(value)) {
				if (value.length === 0) return 'Requis'
			}
			return true
		}
	},
	mounted () {
		if (!this.param) return
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		if (this.value) {
			let int = parseInt(this.value)
			if (!isNaN(int)) this.$emit('update:value', int)
			this.searchBabels(this.value)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/fields/babelid.vue